<template>
    <v-container class="main-container">
        <v-container style="margin-top: 15px;">
            <v-row>
                <v-col cols="12" xl="6" class="text-h4">ご利用料金の確認</v-col>
            </v-row>
        </v-container>

        <!-- 検索エリア -->
        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header color="#F4FEFB">
                </v-expansion-panel-header>
                <v-expansion-panel-content color="#F4FEFB">
                    <form @submit.prevent="search">
                        <v-container>
                            <v-row>
                                <v-col cols="12" xl="1">
                                    <badge-component tile color="unset">
                                        <label-component>対象年月</label-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="2">
                                    <date-picker-component v-model="searchItem.billing_month_from" type="month" placeholder="年/月" displayFormat="YYYYMM"/>
                                </v-col>
                                <p style="padding-top: 25px;">～</p>
                                <v-col cols="12" xl="2">
                                    <date-picker-component v-model="searchItem.billing_month_to" type="month" placeholder="年/月" displayFormat="YYYYMM"/>
                                </v-col>
                                <v-col cols="12" xl="1">
                                    <label-component>
                                        <v-btn
                                            color="blue"
                                            class="white--text"
                                            type="submit"
                                        >
                                            検索
                                        </v-btn>
                                    </label-component>
                                </v-col>
                            </v-row>
                        </v-container>
                    </form>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <div>
            <!-- テーブル -->
            <template>
                <v-pagination
                    v-model="indexInfo.page"
                    :length="indexInfo.pageCount"
                ></v-pagination>
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :page.sync="indexInfo.page"
                    :items-per-page="indexInfo.itemsPerPage"
                    @page-count="indexInfo.pageCount = $event"
                    disable-sort
                    hide-default-footer
                >
                    <template v-slot:body="props">
                        <tr v-for="(item, index) in props.items" :key="index">
                            <td class="item-td" align="center">{{ item.billing_month.slice(0, 4) }} / {{ item.billing_month.slice(4, 6) }}</td>
                            <td class="item-td" align="center">{{ item.plan_name }}</td>
                            <td class="item-td" align="center">{{ item.amount.toLocaleString() }}円（税込）</td>
                            <td class="item-td" align="center">{{ item.send_number }}件</td>
                            <td align="center" ><v-btn color="blue" class="white--text" @click="clickDetail(item)">詳細</v-btn></td>
                       </tr>
                    </template>
                </v-data-table>
            </template>
        </div>


        <!-- 詳細 -->
        <bills-dialog-component v-if="detailDialog" :detailDialog.sync="detailDialog" 
            :item="{
                billing_month: currentItem.billing_month,
                plan_name: currentItem.plan_name,
                plan_amount: currentItem.plan_amount,
                billing_amount: currentItem.amount,
                send_number: currentItem.send_number,
                detail_sign_long_send_count_billing_count: currentItem.detail_sign_long_send_count_billing_count,
                detail_sign_long_send_count_billing_amount: currentItem.detail_sign_long_send_count_billing_amount,
                detail_sign_light_timestamp_send_count_billing_count: currentItem.detail_sign_light_timestamp_send_count_billing_count,
                detail_sign_light_timestamp_send_count_billing_amount: currentItem.detail_sign_light_timestamp_send_count_billing_amount,
                detail_sign_light_send_count_billing_count: currentItem.detail_sign_light_send_count_billing_count,
                detail_sign_light_send_count_billing_amount: currentItem.detail_sign_light_send_count_billing_amount,
                discount_amount: currentItem.discount_amount,
            }"
            @clickOk="reSearch(messageList[0].text)">
            <template v-slot:cancel-btn>閉じる</template>
        </bills-dialog-component>
        
    </v-container>
</template>

<script>
    export default {
        data() {
            return {
                // 検索項目
                searchItem: {
                    billing_month_from: '',
                    billing_month_to: '',
                },
                indexInfo: {
                    // ページ数
                    page: 1,
                    // 最大ページ数
                    pageCount: 0,
                    // 1ページあたりの項目数
                    itemsPerPage: 10,
                },
                // ソート、ページネーション
                options: {},
                // テーブルヘッダー
                headers: [
                  { text: '対象年月', align: 'center', value: 'billing_month' },
                  { text: 'プラン名', align: 'center', value: 'plan_name' },
                  { text: '請求金額', align: 'center', value: 'amount' },
                  { text: '送信件数', align: 'center', sortable: false },
                  { text: '', value: 'action', sortable: false },
               ],
                items: [],
                // 詳細 開閉フラグ
                detailDialog: false,
           };
        },
        methods: {
            // 詳細ボタン押下
            clickDetail(item) {
                this.detailDialog = true;
                this.currentItem = item;
            },
            // 検索
            search() {
                axios.post('/documents/search-bills', this.searchItem).then((res) => {
                    this.items = res.data;
                    console.log(this.data);
                });
            },
            // 再検索
            reSearch(msg) {
                axios.post('/documents/search-bills', this.searchItem).then((res) => {
                    this.items = res.data;
                    this.messageDialog = true;
                    this.msg = msg;
                });
            },
        },
        // 初期表示のデータ
        mounted() {
            axios.get('/documents/get-bills').then(response => this.items = response.data);
        },
    };
</script>

<style scoped lang="scss">
    @import '../../../sass/app.scss';
    .notice-icon {
        margin-right: 10px !important;
    }

    .main-container {
        font-family: $body-font-family;
    }

    .main-content-area {
        margin-top: 10px;
    }

    .common-dialog-message {
        color: black !important;
    }

    /* table */
    .v-btn:not(.v-btn--round).v-size--default {
        margin: 2px 0;
    }
    td {
        border-bottom: solid 1px rgb(0, 0, 0, 0.05);
    }

    /* 検索エリア */
    .v-expansion-panels {
        margin: 10px 0;
    }
    .v-expansion-panel-content__wrap {
        padding-bottom: 0;
    }
</style>